import React, {useEffect, useMemo, useState} from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import parse from 'html-react-parser';
import { Button, Col, Typography, Row, Modal, Input, Spin, message } from 'antd';
import 'antd/dist/antd.css';
import '../App.css';
import FeedbackBanner from './containers/Banner';
import MobileFeedbackBanner from './containers/MobileBanner';
import traitsData from '../traits.json'
import { SERVER_URL } from '../AppRouter'
import Trait from './containers/Distribution'

import { Select } from 'antd';

const traits: Record<string, any> = traitsData;
const { Option } = Select;
const { Text, Title } = Typography;

interface FeedbackProps {
  gameCode?: 'BAR2' | 'TOW2';
}
type ResultsShape = number | Record<string, number>;

const businessColor: { [key: string]: string } = {
  "GENOMA": "#f1715a5",
  "PANDAPE": "#0D3878"
}

const businessImage: { [key: string]: string } = {
  "GENOMA": "https://genoma-assets.s3.us-east-2.amazonaws.com/logo.svg",
  "PANDAPE": "https://genoma-assets.s3.us-east-2.amazonaws.com/pandape.svg"
}

const domainsValues: { [key: string]: string } = {
  "localhost": "PANDAPE",

  "prueba.genoma.work": "GENOMA",
  "pandape.com": "PANDAPE",
  "genoma.pandape.com.br": "PANDAPE",
  "local.genoma.work": "PANDAPE",
};


function Feedback({ gameCode = 'BAR2' }: FeedbackProps) {
  const [results, setResults] = useState<ResultsShape>(0)
  const [source, setSource] = useState('')
  const [askForEmail, setAskForEmail] = useState(true);
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [position, setPosition] = useState(null);
  const [size, setSize] = useState(null);
  const [annualHiring, setAnnualHiring] = useState(null);
  const [industry, setIndustry] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const queryString = new URLSearchParams(window.location.search);
  const gameTraits = {
    BAR2: ['AVRRSG'],
    TOW2: ['CAPPLN', 'EXTPLN'],
  };
  const traitCodes = gameTraits[gameCode];
  const demoRoute = gameCode === 'TOW2' ? '/towers/demo' : '/demo';
  const getScoreForTrait = (code: string): number => {
    if (typeof results === 'number') return results;
    if (results && typeof results === 'object') {
      const key = `${gameCode}_${code}`;      
      return results[key] ?? results[code] ?? 0; 
    }
    return 0;
  };

  const businessType = useMemo(() => {
    const domain = window.location.hostname;
    return domainsValues[domain] || "GENOMA";
  }, []);
  const language: string = useMemo(() => {
    const lang: string | null = queryString.get("lang");
    return lang ? lang.toLowerCase() : 'es';
  }, [queryString]);

  useEffect(() => {
    if (businessType === "PANDAPE") {
      setAskForEmail(false);
    }
  }, [businessType, askForEmail]);


  useEffect(() => {
    setIsLoading(true);
    const token = queryString.get("token") || null
    if (!token){
      navigate("/notFound");
    }
    axios({
      method: 'get',
      url: `${SERVER_URL}?path=feedback&token=${token}`,
      withCredentials: false,
    }).then((response) => {
      if (response.status < 400){
        if (response.data['newRoute'] === 'demo'){
          console.log(response.data['newRoute'])
          navigate(`${demoRoute}?token=${token}`);
          setAskForEmail(true);
        } else {
          const raw = response.data['results'];
          let parsed: ResultsShape = 0;
          if (gameCode === 'TOW2') {
            if (typeof raw === 'string') {
              try { parsed = JSON.parse(raw); } catch { parsed = {}; }
            } else if (raw && typeof raw === 'object') {
              parsed = raw;
            } else if (typeof raw === 'number') {
              parsed = { TOW2_CAPPLN: raw };
            } else {
              parsed = {};
            }
          } else {
            parsed = raw;
          }
          setResults(parsed)
          setSource(response.data['source'])
          setAskForEmail(response.data['email'] ? response.data['email'].includes('@null') : true)
        }
      }
      setIsLoading(false);
    }).catch((error) => {
      setIsLoading(false);
      navigate("/notFound");
    });
  }, [])

  const showError = (content: string) => {
    Modal.error({
      title: 'Error',
      content,
    });
    setIsLoading(false);
  };

  const isEmailCorrect = (email: string) => {
    const emailRegex = "([aA-zZ0-9\-\.\_\+]{3,}\@[aA-zZ0-9\-\.\_\+]{2,}\.[aA-zZ0-9]{2,6})"
    if (email.match(emailRegex)){
      return true;
    }
    return false;
  }

  const handleSubmit = () => {
    setIsLoading(true);
    if (!email || !firstName || !lastName || !phone || !position || !size || !industry) {
      showError('Por favor completa todos los campos obligatorios.');
      return;
    }

    if (!isEmailCorrect(email)) {
      showError('Ingresa un correo válido');
      return;
    }

    const submit = {
      email:email,
      firstname:firstName,
      lastname:lastName,
      phone:phone,
      jerarquia_nueva:position,
      tamano_de_la_empresa:size,
      contrataciones_anuales: annualHiring,
      indutria:industry,
      utm_source:queryString.get("utm_source"),
      utm_medium:queryString.get("utm_medium"),
      utm_campaign:queryString.get("utm_campaign"),
      utm_content:queryString.get("utm_content"),
      utm_term:queryString.get("utm_term")
    };

    const token = queryString.get("token") || null

    axios({
      method: 'post',
      url: `${SERVER_URL}?path=update_email&token=${token}`,
      withCredentials: false,
      data: submit,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (response.status < 400){
        setAskForEmail(false);
        setIsLoading(false);
      }
    }).catch((error) => {
      Modal.error({
        title: 'Error',
        content: 'Ocurrió un error, intenta nuevamente.',
      });
      setIsLoading(false);
      // navigate("/notFound");
    });
  }
  
  function getTextHtml (text : string) {
    let htmlText : string;
    let i : number;
    i = 0;
    let isEven : boolean;
    isEven = false;
    htmlText = '<div style="fontSize: 2vh" >';
    while (i < text.length){
      let subtext : string;
      subtext = text.substring(i, i+1);
      if (subtext === '*'){
        subtext = text.substring(i, i+2);
        if (!isEven && subtext.includes('**')){
          isEven = true;
          subtext = subtext.replace('**', '<b style="font-weight: 700;fontSize: 2vh">')
          i += 1;
        } 
        if (isEven && subtext.includes('**')){
          isEven = false;
          subtext = subtext.replace('**', ' </b>')
          i += 1;
        } 
      }
      i += 1;
      htmlText += subtext;
    }
    htmlText += '</div>'
    return htmlText
  }
  return (
    <Spin spinning={isLoading}>
      <div style={{ width: '100%' }}>
      {businessType === 'GENOMA' &&  <Row className='navbar' style={{display:'flex', flexDirection:'row'}}>
        <Col sm={2} style={{ marginLeft: '2vh', marginTop: '0.5rem'}}>
          <img src='https://genoma-assets.s3.us-east-2.amazonaws.com/logo.svg' alt='' style={{maxHeight:'3vh'}} />
        </Col>
      </Row>}
      {/* {window.innerWidth > 718
        ? <FeedbackBanner gameCode={gameCode} />
        : <MobileFeedbackBanner gameCode={gameCode} />} */}

      {businessType === "GENOMA" && (
        window.innerWidth > 718 ? <FeedbackBanner/> : <MobileFeedbackBanner/>
      )}


      {askForEmail ? 
      <Row align='middle' justify='center' style={{ width: '100%', height: '100%', marginTop: 20 }}>
        {isLoading ? null : <Col span={12}>
          <Text style={{ fontSize: '2.0vh' }}>
            Ingresa tus datos para ver tus resultados.
          </Text>
          <Row align='middle' justify='center' style={{ width: '100%', marginTop: 20 }}>
            <Col xs={24}>
              <Text style={{ fontSize: '1.8vh' }}>
                Correo corporativo              </Text>
              <Input
                value={email}
                placeholder=''
                type='email'
                onChange={(e) => {
                  const email = (e.target.value)?.toLowerCase();
                  const invalidEmails = ['gmail', 'outlook', 'yahoo', 'hotmail', 'icloud'];
                  const contains = invalidEmails.some(item => email.toLocaleLowerCase().includes(item));
                  if (contains) {
                    message.error('Ingresa un correo corporativo válido');
                  }
                  else{
                    setEmail(email)
                  }
                }}
              />
            </Col>
          </Row>
          <Row align='middle' justify='center' style={{ width: '100%', marginTop: 20 }}>
            <Col xs={12}>
              <Text style={{ fontSize: '1.8vh' }}>
                Nombre
              </Text>
              <Input
                value={firstName}
                placeholder=''
                type='text'
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Col>
            <Col xs={12}>
              <Text style={{ fontSize: '1.8vh' }}>
                Apellido
              </Text>
              <Input
                value={lastName}
                placeholder=''
                type='text'
                onChange={(e) => setLastName(e.target.value)}
              />
            </Col>
          </Row>
          <Row align='middle' justify='center' style={{ width: '100%', marginTop: 20 }}>
            <Col xs={12}>
            <Text style={{ fontSize: '1.8vh' }}>
              Número de teléfono
            </Text>
            <Input
              value={phone}
              placeholder='987654321'
              type='tel'
              addonBefore="+56"
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                setPhone(value);
              }}
            />
            </Col>
            <Col xs={12}>
            <Text style={{ fontSize: '1.8vh' }}>
              Selecciona tu cargo
            </Text>
            <Select
              value={position}
              placeholder="Selecciona"
              onChange={(value) => setPosition(value)}
              style={{ width: '100%' }}
            >
              <Option value="Director">Director</Option>
              <Option value="Gerente">Gerente</Option>
              <Option value="Jefe">Jefe</Option>
              <Option value="Coordinador">Coordinador</Option>
              <Option value="Analista">Analista</Option>
            </Select>
            </Col>
          </Row>
          <Row align='middle' justify='center' style={{ width: '100%', marginTop: 20 }}>
            <Col xs={12}>
              <Text style={{ fontSize: '1.8vh' }}>
                ¿De qué tamaño es tu empresa?
              </Text>
              <Select
                value={size}
                placeholder="Selecciona"
                onChange={(value) => setSize(value)}
                style={{ width: '100%' }}
              >
                <Option value="0-50">0 - 50</Option>
                <Option value="51-200">51 - 200</Option>
                <Option value="201-500">201 - 500</Option>
                <Option value="501 - 1000">501 - 1.000</Option>
                <Option value="1.000 - 5.000">1.001 - 5.000</Option>
                <Option value="5.000 - 10.000">5.001 - 10.000</Option>
                <Option value="> 1000"> {'>'} 10.000</Option>
              </Select>
            </Col>
            <Col xs={12}>
              <Text style={{ fontSize: '1.8vh' }}>
                ¿Cuántas personas contratan al año?
              </Text>
              <Select
                value={annualHiring}
                placeholder="Selecciona"
                onChange={(value) => setAnnualHiring(value)}
                style={{ width: '100%' }}
              >
                <Option value="0 - 29">0 - 29</Option>
                <Option value="30 - 50">30 - 50</Option>
                <Option value="51 - 100">51 - 100</Option>
                <Option value="101 - 200">101 - 200</Option>
                <Option value="201 - 500">201 - 500</Option>
                <Option value="> 501">{'>'} 501</Option>
              </Select>
            </Col>
          </Row>
          <Row align='middle' justify='center' style={{ width: '100%', marginTop: 20 }}>
            <Col xs={12}>
            <Text style={{ fontSize: '1.8vh' }}>
              Industria de tu empresa
            </Text>
            <Select
              value={industry}
              placeholder="Selecciona"
              onChange={(value) => setIndustry(value)}
              style={{ width: '100%' }}
            >
              <Option value="Medios de comunicación">Medios de comunicación</Option>
              <Option value="Agricultura, ganadería y agropecuario">Agricultura, ganadería y agropecuario</Option>
              <Option value="Automotriz">Automotriz</Option>
              <Option value="Bienes raíces">Bienes raíces</Option>
              <Option value="Call center">Call center</Option>
              <Option value="Construcción y Minería">Construcción y Minería</Option>
              <Option value="Consultora de RRHH">Consultora de RRHH</Option>
              <Option value="Ecommerce">Ecommerce</Option>
              <Option value="Educación">Educación</Option>
              <Option value="Energía">Servicios basicos, energía y residuos</Option>
              <Option value="Gobierno y organizaciones sin fines de lucro">Gobierno y organizaciones sin fines de lucro</Option>
              <Option value="Inmobiliaria">Inmobiliaria</Option>
              <Option value="Manufactura">Manufactura</Option>
              <Option value="Producción de alimentos y bebidas">Producción de alimentos y bebidas</Option>
              <Option value="Retail">Retail</Option>
              <Option value="Salud, laboratorios y bienestar integral">Salud y Laboratorios</Option>
              <Option value="Seguros">Seguros</Option>
              <Option value="Servicios financieros y Banca">Servicios financieros y Banca</Option>
              <Option value="Servicios profesionales y consultoras">Servicios profesionales y consultoras</Option>
              <Option value="Supermercados, Tiendas de conveniencia y Farmacias">Supermercados, Tiendas de conveniencia y Farmacias</Option>
              <Option value="Tecnología, Servicios de TI y software">Tecnología, Servicios de TI y software</Option>
              <Option value="Telecomunicaciones">Telecomunicaciones</Option>
              <Option value="Transporte y logística">Transporte y logística</Option>
              <Option value="Viajes, turismo, entretenimiento, restaurantes">Viajes, turismo, entretenimiento, restaurantes</Option>
            </Select>
            </Col>
          </Row>
          <Row align='middle' justify='center' style={{ width: '100%', marginTop: 20 }}>
            <Col xs={24}>
              <Button className='send-button' style={{ backgroundColor: '#f1715a5' }} onClick={handleSubmit}>
                Enviar
              </Button>
            </Col>
          </Row>

        </Col>   }   
      </Row> : 
      
      <Row gutter={[24,24]} style={{display: 'flex' ,flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        {traitCodes.map((code) => {
          const t = traits[language][code];
          const score = getScoreForTrait(code);
          return (
            <Col key={code} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <Row className='feedback-layout' style={{ marginTop:'2em', marginLeft: 'auto', marginRight: 'auto', width: '90%' }}>
                <Title style={{ fontSize: '2.4vh'}} >
                  {t['title']}
                </Title>
                {parse(getTextHtml(t['traitDescription']))}
                <div style={{minHeight:'50vhs', marginTop:'2em'}}>
                  <Trait
                  result={score}
                  mobile={window.innerWidth < 718}
                  traitsDescription={t['levelDescription']}
                  gameCode={gameCode}
                  terciles={t['terciles']}
                  traitCode={code}

                  />
                </div>
              </Row>
            </Col>
          );
        })}
      </Row>}

    </div>

    </Spin>
  );
}

export default Feedback;